"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForeignRefVisitor = void 0;
const visitor_base_1 = require("./visitor.base");
class ForeignRefVisitor extends visitor_base_1.VisitorBase {
    currentTabId;
    foreignTabs;
    constructor(currentTabId) {
        super();
        this.currentTabId = currentTabId;
        this.foreignTabs = new Set([]);
    }
    visitForeign(node) {
        this.foreignTabs.add(node.tab?.id ?? node.tabToken);
    }
    visitColumn(node) {
        this.foreignTabs.add(this.currentTabId);
    }
}
exports.ForeignRefVisitor = ForeignRefVisitor;
